/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateTicketSubsidyDto } from '../../models/create-ticket-subsidy-dto';
import { TicketSubsidyLogDto } from '../../models/ticket-subsidy-log-dto';

export interface TicketSubsidyControllerUpdateTicketSubsidy$Params {
  id: string;
  ticketId: string;
  centerUserId: string;
      body: CreateTicketSubsidyDto
}

export function ticketSubsidyControllerUpdateTicketSubsidy(http: HttpClient, rootUrl: string, params: TicketSubsidyControllerUpdateTicketSubsidy$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketSubsidyLogDto>> {
  const rb = new RequestBuilder(rootUrl, ticketSubsidyControllerUpdateTicketSubsidy.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('ticketId', params.ticketId, {});
    rb.query('centerUserId', params.centerUserId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TicketSubsidyLogDto>;
    })
  );
}

ticketSubsidyControllerUpdateTicketSubsidy.PATH = '/api/ticket-subsidy/{id}';
